
import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';


export type GetDataQualityTriggersForItemRequestParams = {
  readonly contentItemType: string;
  readonly contentItemLuid: string;
}

export function getGetDataQualityTriggersForItemRequestConfig(
  params: GetDataQualityTriggersForItemRequestParams
): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.10',
    httpMethod: 'GET',
    endpoint: `dataQualityTriggers/${params.contentItemType}/${params.contentItemLuid}`,
    serverWideRequest: false,
  };
}

export type DataQualityTriggerInfo = {
  readonly id: string;
  readonly contentId: string;
  readonly contentType: string;
  readonly message: string;
  readonly type: 'EXTRACT_REFRESH' | 'FLOW_RUN';
  readonly active: boolean;
  readonly severe: boolean;
}

/** The response actually has more fields but I'm only modeling what we're currently using */
export type GetDataQualityTriggersForItemResponse = {
  readonly dataQualityTriggerList: {
    readonly dataQualityTrigger: ReadonlyArray<DataQualityTriggerInfo>;
  };
};

export function callViaApiService(
  params: GetDataQualityTriggersForItemRequestParams
) {
  return makeJsonRestApiRequest<void, GetDataQualityTriggersForItemResponse>({
    config: getGetDataQualityTriggersForItemRequestConfig(params),
    request: null,
  });
}

export function makeFetchInitialStateForTriggers<P, S>(
  params: GetDataQualityTriggersForItemRequestParams,
  transform: (t: DataQualityTriggerInfo) => S
  ): undefined | ((bodyProps: P, dialogState: S) => Promise<S>) {
    return async (bodyProps: P, dialogState: S) => {
      try {
        const result = await callViaApiService(params);
        const triggers = result.dataQualityTriggerList;

        if (!triggers) {
          return dialogState;
        }

        const trigger = triggers.dataQualityTrigger[0];
        if (!trigger){
          return dialogState;
        }
        return transform(trigger);

      } catch {
        return dialogState;
      }
    };
  }